import { Box } from '@mui/material';
import { FOCUS_MODE_BORDERS, getFocusModeValue } from '@src/constants/design-tokens';
import { COLORS } from '@src/constants/design-tokens/colors';
import { memo } from 'react';
import { useTranslation } from 'react-i18next';

interface FocusModeIndicatorProps {
  isFocusMode: boolean;
}

export const FocusModeIndicator = memo(({ isFocusMode }: FocusModeIndicatorProps) => {
  const { t } = useTranslation();

  if (!isFocusMode) {
    return null;
  }

  return (
    <Box
      sx={{
        backgroundColor: COLORS.focusModeNav.indicator.background,
        color: COLORS.focusModeNav.indicator.text,
        fontSize: { xs: '0.6rem', sm: '0.65rem' },
        fontWeight: 400,
        letterSpacing: '0.05em',
        padding: { xs: '3px 6px', sm: '4px 8px' },
        borderRadius: '12px',
        backdropFilter: 'blur(8px)',
        border: `1px solid ${getFocusModeValue(FOCUS_MODE_BORDERS, 'buttonLight', isFocusMode)}`,
        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.4)',
        whiteSpace: 'nowrap',
        marginLeft: { xs: 0.5, sm: 1 },
        display: { xs: 'none', sm: 'flex' }, // 小さな画面では非表示
        alignItems: 'center',
        minHeight: { xs: '20px', sm: '24px' },

        // 出現時のエフェクト - 心地よい短時間
        opacity: 0,
        transform: 'translateY(-6px) scale(0.9)',
        filter: 'blur(4px)',
        animation: 'focusAppear 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94) 0.15s forwards',

        '@keyframes focusAppear': {
          '0%': {
            opacity: 0,
            transform: 'translateY(-6px) scale(0.9)',
            filter: 'blur(4px)',
          },
          '70%': {
            opacity: 0.8,
            transform: 'translateY(-1px) scale(1.02)',
            filter: 'blur(1px)',
          },
          '100%': {
            opacity: 1,
            transform: 'translateY(0) scale(1)',
            filter: 'blur(0px)',
          },
        },
      }}
    >
      {t('navigation.focusIndicator')}
    </Box>
  );
});
